import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-entity-list',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-entity-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonEntityListComponent {
  nItems = Array.from({ length: 10 }, (_, i) => i);
}
